export default __webpack_public_path__ + "static/globalmap2022-2-01-bafba36e809112a921192898e5e0e7eb.svg";